import { getId } from '@shared/helpers/object.helpers';
import type { Shape, Storey } from '@shared/models/design/storey.model';
import type { ItemOrItemId } from '@shared/models/type-helpers.model';

/**
 * Get a {@link Shape} by id from a {@link Storey}.
 *
 * This helper exists to avoid importing `shape.helpers.ts` from mutators, since `shape.helpers.ts`
 * imports `design.helpers.ts` which imports `mutateDesign` and can create circular imports in vitest.
 */
export const getShapeByIdFromStorey = (
  storey: Storey | undefined,
  shapeOrId: ItemOrItemId<Shape>,
): Shape | undefined => {
  if (!storey) return undefined;
  const id = getId(shapeOrId);
  return storey.shapes.find((s) => s.id === id);
};
